// PipelineSection.jsx
// Visualises the 3-layer engine pipeline so users understand
// this is a real calculation system, not guesswork.
import React from "react";

export default function PipelineSection({ heading, subheading, steps = [] }) {
  return (
    <div className="sx-container">
      <div className="sx-pipeline-wrapper">
        {heading && (
          <h3 className="sx-pipeline-heading">{heading}</h3>
        )}
        {subheading && (
          <p className="sx-pipeline-sub">{subheading}</p>
        )}

        <div className="sx-pipeline-steps">
          {steps.map((step, i) => (
            <React.Fragment key={i}>
              {/* Step card */}
              <div className="sx-pipeline-step">
                <div className="sx-pipeline-step-num">{i + 1}</div>
                <div className="sx-pipeline-step-icon">{step.icon}</div>
                <div className="sx-pipeline-step-title">{step.title}</div>
                <div className="sx-pipeline-step-body">{step.body}</div>
                {step.tags && (
                  <div className="sx-pipeline-step-tags">
                    {step.tags.map((tag, j) => (
                      <span key={j} className="sx-pipeline-tag">{tag}</span>
                    ))}
                  </div>
                )}
              </div>

              {/* Arrow connector (not after last) */}
              {i < steps.length - 1 && (
                <div className="sx-pipeline-arrow" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10h12M12 6l4 4-4 4" stroke="#f59e0b" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
